import { useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      whileInView={reduce ? { opacity: 1 } : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const LineReveal = ({ lines, className, lineClassName, delay = 0.25 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.12em] -mb-[0.12em]">
          <motion.span
            className={`block ${lineClassName || ""}`}
            initial={reduce ? { opacity: 0 } : { y: "112%" }}
            animate={reduce ? { opacity: 1 } : { y: 0 }}
            transition={{ duration: 1, delay: delay + i * 0.16, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

export const Marquee = ({ items, className, itemClassName }) => (
  <div className={`marquee-mask overflow-hidden ${className || ""}`} aria-hidden="true">
    <div className="animate-marquee flex w-max items-center">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center">
          {items.map((item, i) => (
            <span key={i} className={`flex items-center whitespace-nowrap ${itemClassName || ""}`}>
              <span>{item}</span>
              <span className="mx-8 text-gold-soft">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export const ParallaxImage = ({ src, alt, className, imgClassName, speed = 42 }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], reduce ? [0, 0] : [-speed, speed]);
  return (
    <div ref={ref} className={`overflow-hidden ${className || ""}`}>
      <motion.img
        style={{ y }}
        src={src}
        alt={alt}
        className={`h-full w-full object-cover scale-[1.15] ${imgClassName || ""}`}
        loading="lazy"
      />
    </div>
  );
};
